<template>
  <div>
    <div class="ls_drawer_main_content">
      <h1 class="item_detail_header mb-30">
        {{ detail.name }}
        <Tag v-show="detail.default" color="success">По-умолчанию</Tag>
        <Tag v-show="detail.deleted_date" color="error">Удален</Tag>
      </h1>

      <div class="fs-15 color-grey mb-30">
        <!-- CREATED DATE -->
        <Row>
          <Col span="12">
            Дата создания:
          </Col>
          <Col span="12">
            {{ formatDateTime(detail.created_date) }}
          </Col>
        </Row>

        <!-- ADDRESS -->
        <Row>
          <Col span="12">
            Адрес:
          </Col>
          <Col span="12">
            {{ detail.address }}
          </Col>
        </Row>

        <!-- TIMEZONE -->
        <Row>
          <Col span="12">
            Часовой пояс:
          </Col>
          <Col span="12">
            {{ detail.timezone_display }}
          </Col>
        </Row>

        <!-- DESCRIPTION -->
        <Row>
          <Col span="12">
            Описание:
          </Col>
          <Col span="12">
            {{ detail.description }}
          </Col>
        </Row>
      </div>


      <!-- SECTIONS -->
      <Divider class="mb-30"><h2>Отделы</h2></Divider>

      <Tag
        v-for="section in sections"
        :key="section.id"
        :name="section.id"
        closable
        @on-close="deleteSection"
      >{{ section.name }}
      </Tag
      >

      <div align="right">
        <Button type="info" size="small" @click="addSection"
        >Добавить
          <Icon type="md-add-circle"/>
        </Button>
      </div>


      <Modal
        v-model="showAddSectionModal"
        title="Добавление отдела"
        @on-ok="saveSection"
        @on-cancel=""
      >
        <Input
          v-model="formSectionData.name"
          placeholder="Введите название отдела"
        />
      </Modal>




      <!-- CASH -->
      <Divider class="mb-30"><h2>Кассы</h2></Divider>

      <Row gutter="24">
        <Col span="12" class="mb-10" v-for="item in storeCash">
          <router-link :to="'/cash/detail/' + item.id">
            <div class="card-container">{{item.name}}</div>
          </router-link>
        </Col>
      </Row>




      <Divider><h2>Последние операции</h2></Divider>

      <!-- RECENT OPERATIONS -->
      <div style="text-align: center;">
        <RadioGroup v-model="doc_tab_switch" type="button" class="d-flex justify-center">
          <Radio :label="doc_tab_switch_labels[0]"></Radio>
          <Radio :label="doc_tab_switch_labels[1]"></Radio>
        </RadioGroup>
      </div>

      <recentProductOrders
        v-if="doc_tab_switch === doc_tab_switch_labels[0]"
        style="min-height: 20%; margin-top: 20px"
        filter_by="store"
        :filter_by_id="id"
      ></recentProductOrders>

      <recentMoneyOrders
        v-else
        style="min-height: 20%; margin-top: 20px"
        filter_by="store"
        :filter_by_id="id"
      ></recentMoneyOrders>

    </div>
    <div class="ls_drawer_footer" style="margin-top: 20px">
      <Button style="margin-right: 8px" type="primary" @click="cancelAction()">
        <Icon type="md-close"/>
      </Button>
      <Button style="margin-right: 8px" v-if="display_edit_button" type="info" @click="editAction()">
        <Icon type="md-create"/>
      </Button>
      <Button v-if="display_delete_button" type="error" @click="removeModal = true" style="float: left"
      >
        <Icon type="md-trash"/>
      </Button>
    </div>



    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данный магазин?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteAction(detail.name)">
          Удалить
        </Button>
      </Row>
    </Modal>



    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
    import {BaseDetailData} from "../../base/base_detail.js";
    import recentProductOrders from "../../components/core/recentProductOrders";
    import recentMoneyOrders from "../../components/core/recentMoneyOrders";

    let _app = BaseDetailData();

    _app.data = function () {
        return {
            loading: true,
            detail: {},

            //  Additional nested data
            sections: [],
            showAddSectionModal: false,
            formSectionData: {
                name: ""
            },

            storeCash: '',

            doc_tab_switch: "Движение товара",
            doc_tab_switch_labels: ["Движение товара", "Движение денег"],

            removeModal: false,
            removeId: null,
            footerHide: true,
        };
    };

    _app.components = {
        recentProductOrders,
        recentMoneyOrders
    };
    _app.methods.fetchSections = function () {
        this.$http
            .get(this.base_view_url + this.id + "/get_sections/")
            .then(response => {
                this.sections = response.data.results;
            })
            .finally(() => {
                this.loading = false;
            });
    };


    _app.methods.deleteSection = function (event, name) {
        let index = 0;
        for (let section of this.sections) {
            if (section.id === name) {
                this.sections.splice(index, 1);
                break;
            }
            index++;
        }

        let url = this.base_view_url + this.id + "/sections/" + name + "/";
        this.$http
            .delete(url)
            .then(response => {
                this.$Message.success("Успешно удален");
            })

    };
    _app.methods.addSection = function (event, name) {
        this.showAddSectionModal = true;
    };

    _app.methods.saveSection = function () {
        let url = this.base_view_url + this.id + "/add_section/";
        this.$http
            .post(url, this.formSectionData)
            .then(response => {
                this.$Message.success("Успешно добавлен");
                this.sections.push(response.data);
            })
    };


    _app.methods.fetchCash = function () {
        this.$http
            .get(this.base_view_url + this.id + "/cashes/")
            .then(response => {
                this.storeCash = response.data;
            })
            .finally(() => {
                this.loading = false;
            });
    };

    _app.mounted = function () {
        this.fetchSections();
        this.fetchCash();
    };

    _app.methods.editAction = function () {
        this.$router.push({
            name: this.item_type + "_edit",
            params: {id: this.id}
        });
    };
    export default _app;
</script>

<style scoped>
  .card-container {
    padding: 12px;
    font-size: 15px;
  }
  .card-container:hover {
    background-color: #5296f0;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/apps/store/storeDetail.vue